<button mat-stroked-button 
    (click)="clickButton()" 
    [disabled]="disabled"
    title="{{'attach / detach' | translate:['tmc-yard.widgets.sac-client.station-transport-details.action.attach-detach', translationService.language]}}"
    *ngIf="asButton">
    <sc-icon iconClass="fa-code-merge"></sc-icon>
</button>
<button mat-icon-button 
    (click)="clickButton()" 
    [disabled]="disabled"
    title="{{'attach / detach' | translate:['tmc-yard.widgets.sac-client.station-transport-details.action.attach-detach', translationService.language]}}"
    *ngIf="!asButton">
    <sc-icon iconClass="fa-code-merge"></sc-icon>
</button>